import styled from 'styled-components';
import theme from '../../theme';

const StyledLockUnlockWallet = styled.div`
.wallet-status-red{
  color: ${theme.primaryColor};
}
.wallet-status-green{
  color: ${theme.btnGreen};
}
.custom-switch{
  &.ant-switch-checked{
    background-color: ${theme.btnGreen};
  }
}
`;

export default StyledLockUnlockWallet;



// WEBPACK FOOTER //
// client/containers/YscWalletLockUnlock/StyledWalletLockUnlock.js